import { render, staticRenderFns } from "./EvolutionLastYear.vue?vue&type=template&id=63cdd27a&lang=pug"
import script from "./EvolutionLastYear.vue?vue&type=script&lang=js"
export * from "./EvolutionLastYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports